import React, { createContext, useContext, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import { useAppContext } from "./Provider";
import { SuspenseSkeleton } from "./SuspenseSkeleton";

interface IRouterWrapperProps {
    namespace: string;
    namespaces?: string[];
}

const RouterContext = createContext({
    pathname: "/"
});
export const RouterWrapper = ({ namespace, namespaces }: IRouterWrapperProps) => {
    const appContext = useAppContext();
    const topRouterContext = useContext(RouterContext);
    const RoutePages = useMemo(() => {
        const unames = [...(namespaces || []), namespace];
        const pageList: AppView.IPageEx[] = [];
        unames.forEach((name) => {
            const pageArray = appContext.config.pages[name] || [];

            pageList.push(...pageArray.map((page) =>({
                ...page,
                urlPrefix: (pageArray as any).urlPrefix || "/",
            })));
        });
        return pageList;
    }, [appContext, namespace]);

    return (
        <Routes>
        {
            RoutePages.length > 0 && RoutePages.map((page,index) => {
                const Component = page.Component;
                const configPathName = (page as any).routerPathName;
                const pathname = page.children && page.children?.length > 0 ? configPathName + "/*" : configPathName;
                const pageKey = `${page.id}_${index}`;
                const extractData = (Component as any).extract || {};
                const state = page.state || {};
                return (<Route
                        key={pageKey}
                        element={
                            <SuspenseSkeleton key={pageKey}>
                                <Component key={pageKey} {...extractData} routerState={state} />
                            </SuspenseSkeleton>
                        }
                        path={pathname}
                        caseSensitive
                    />
                );
            })
        }
        </Routes>
    );
};